import { useEffect } from 'react';

import '@elastic/charts/dist/theme_light.css';

import { useThemeStore } from '@/store';

/**
 * Dynamically swaps the Elastic Charts stylesheet (light/dark)
 * by injecting a <link> tag to the appropriate file in /public/vendor/
 */
export const ChartStyleLoader = () => {
  const theme = useThemeStore((s) => s.theme);

  useEffect(() => {
    const id = 'elastic-charts-theme';
    let link = document.getElementById(id) as HTMLLinkElement | null;

    if (!link) {
      link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }

    link.href = `/vendor/theme_only_${theme}.css`;
  }, [theme]);

  return null;
};
